import React from 'react';
import PropTypes from 'prop-types';
//Styles
import { useStyles } from 'components/dialogs/account/DialogAccount.style';
//Locales
import translate from 'locales/i18n';
//Mui components
import {
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    TextField
} from '@mui/material';
// Currencies & countries
import currencies from 'currencies.js';
import { countries } from 'countries';

const DialogManageAccountInfo = ({
    errorMessage,
    handleChange,
    isEdit,
    newAccount,
    sites
}) => {
    const classes = useStyles();

    return <div className={classes.stepContainer}>
        <TextField
            required
            label={translate.i18n('NAME')}
            value={newAccount.name}
            variant='outlined'
            className={classes.textField}
            onChange={event => handleChange('name', event.target.value)}
            disabled={isEdit}
        />
        <FormControl variant='outlined'
            classes={{
                root: classes.formControl
            }}>
            <InputLabel>
                {translate.i18n('TYPE')}
            </InputLabel>
            <Select
                value={newAccount.type}
                label={translate.i18n('TYPE')}
                onChange={event => handleChange('type', event.target.value)}
            >
                <MenuItem value={'RETAILER'}>Retailer</MenuItem>
                <MenuItem value={'SUPPLIER'}>Supplier</MenuItem>
            </Select>
        </FormControl>
        <FormControl variant='outlined'
            disabled={newAccount.type !== 'RETAILER'}
            classes={{
                root: classes.formControl
            }}>
            <InputLabel
                htmlFor='outlined'
                margin={'dense'}>
                {translate.i18n('SITE')}
            </InputLabel>
            <Select
                native
                value={newAccount.siteId}
                label={translate.i18n('SITE')}
                onChange={event => handleChange('siteId', event.target.value)}
            >
                <option aria-label='None' value={''}></option>
                {sites.map(s => <option value={s.id} key={s.id}>{s.name}</option>)}
            </Select>
        </FormControl>
        <TextField
            required
            label={translate.i18n('EMAIL')}
            value={newAccount.email}
            variant='outlined'
            className={classes.textField}
            onChange={event => handleChange('email', event.target.value)}
        />
        <TextField
            required
            label={translate.i18n('LOGO_URL')}
            value={newAccount.logoUrl}
            variant='outlined'
            className={classes.textField}
            onChange={event => handleChange('logoUrl', event.target.value)}
        />
        <FormControl variant='outlined'
            classes={{
                root: classes.formControl
            }}>
            <InputLabel
                htmlFor='outlined'
                margin={'dense'}>
                {translate.i18n('CURRENCY')}
            </InputLabel>
            <Select
                value={newAccount.currency}
                onChange={event => handleChange('currency', event.target.value)}
                label={translate.i18n('CURRENCY')}
            >
                {currencies.map((c, key) => <MenuItem value={c.code} key={key}>{c.symbol + ' (' + c.name + ')'}</MenuItem>)}
            </Select>
        </FormControl>
        <FormControl variant='outlined'
            classes={{
                root: classes.formControl
            }}>
            <InputLabel
                htmlFor='outlined'
                margin={'dense'}>
                {translate.i18n('SHIPPING_COUNTRY')}
            </InputLabel>
            <Select
                value={newAccount.shippingCountry}
                onChange={event => handleChange('shippingCountry', event.target.value)}
                label={translate.i18n('SHIPPING_COUNTRY')}
            >
                {countries.map(country => <MenuItem value={country.code} key={country.code}>{country.label}</MenuItem>)}
            </Select>
        </FormControl>
        <FormControl variant='outlined'
            classes={{
                root: classes.formControl
            }}>
            <InputLabel
                htmlFor='outlined'
                margin={'dense'}>
                {translate.i18n('TAX_MODE')}
            </InputLabel>
            <Select
                value={newAccount.taxMode}
                onChange={event => handleChange('taxMode', event.target.value)}
                label={translate.i18n('TAX_MODE')}
            >
                <MenuItem value={''}>None</MenuItem>
                <MenuItem value={'EXCL'}>Hors Taxes</MenuItem>
                <MenuItem value={'INCL'}>Toutes Taxes Comprises</MenuItem>
            </Select>
        </FormControl>
        {errorMessage ?
            <p className={classes.errorMsg}>{errorMessage}</p>
            :
            null
        }
    </div>;
};

DialogManageAccountInfo.propTypes = {
    errorMessage: PropTypes.string,
    handleChange: PropTypes.func,
    isEdit: PropTypes.bool,
    newAccount: PropTypes.object,
    sites: PropTypes.array
};

export default DialogManageAccountInfo;
